<div class="row justify-content-center">

  <div class="col-lg-8 content-area">
    <div class="page-card">
      <div id="submissionhistorysdata">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'submissionhistorysdata'">
          Submission History
        </h2>

        <p class="f-s-14">
          This section maintains a record of all submitted reports and filings. It allows you to track important details such as submission dates, and submission statuses, providing an easy reference for compliance and audit purposes.
        </p>

        <img style="max-width: 895px;" src="../../../../assets/images/logos/submissionhistory.png" />
      </div>

      <div id="search-submissions">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'search-submissions'">
          Search Submissions
        </h2>

        <p class="f-s-14">
          You can use this option to search for a specific submission by entering the relevant details.
        </p>

        <p class="f-s-14">
          Click on a record to view the submission details. All submission information for the selected charity will be displayed.
        </p>
      </div>
      <div id="filter">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'filter'">
          Filter
        </h2>

        <p class="f-s-14">
          Select the required <strong>Date</strong>, <strong>Status</strong> or <strong>Accounting Period</strong> filters and click <strong>Apply</strong>. The submission history will be updated according to the selected filter values.
        </p>

      </div>

      <div id="show-error">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'show-error'">
          Show Error
        </h2>

        <p class="f-s-14">
          If any errors occur during the submission process, the details of the errors will be displayed.
        </p>

        <p class="f-s-14">
          You will also have the option to download the error report for further review.
        </p>

        
       <img src="../../../../assets/images/logos/submissionerrorlog1.jpg" /> 

      </div>

      <div id="print-fbi-receipt">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'print-fbi-receipt'">
          Print FBI Receipt
        </h2>

        <p class="f-s-14">
          You can print the File by Internet Receipt.
        </p>

        <p class="f-s-14">
          And you will have below mentioned options:
        </p>

        <ul class="f-s-14">

          <li>
            <strong class="f-s-16">Toggle Sidebar</strong> - You can select and view any page of the report.
          </li>

        </ul>

        <img style="margin-left: 40px;" src="../../../../assets/images/logos/togglesidebar.png" />

        <ul class="f-s-14">

          <li>
            <strong class="f-s-16">Find in Document</strong> - You search any particular part from the report.
          </li>

        </ul>

        <img style="margin-left: 40px;" src="../../../../assets/images/logos/findindocument.jpg" />

        <ul class="f-s-14">

          <li>
            <strong class="f-s-16">  Previous &amp; Next Page</strong> - You can jump to the previous and next page.<img style="vertical-align: middle; height: 30px;" src="../../../../assets/images/logos/prevnextpage.png" />
          </li>

        </ul>

        

        <ul class="f-s-14">

          <li>
            <strong class="f-s-16">Automatic Zoom</strong> - You can zoom in or zoom out with this option.<img style="height: 30px; vertical-align: middle" src="../../../../assets/images/logos/automaticzoom.jpg" />
          </li>

        </ul>

        

        <ul class="f-s-14">

          <li>
            <strong class="f-s-16"> Switch to Presentation Mode</strong> - You can switch the report to the presentation mode.<img style="height: 30px; vertical-align:middle" src="../../../../assets/images/logos/view.jpg" />
          </li>

        </ul>

        <ul class="f-s-14">

          <li>
            <strong class="f-s-16">Open File</strong> - You can open file on the system.<img style="height: 30px; vertical-align:middle" src="../../../../assets/images/logos/open.png" />
          </li>

        </ul>


        <ul class="f-s-14">

          <li>
            <strong class="f-s-16">Print &amp; Download</strong> - You can print &amp; download the report.<img style="height: 30px; vertical-align:middle" src="../../../../assets/images/logos/printdownload.png" />
          </li>

        </ul>

        <ul class="f-s-14">

          <li>
            <strong class="f-s-16">Current View</strong> - You can copy or open the current view in new tab.<img style="height: 30px; vertical-align:middle" src="../../../../assets/images/logos/save.jpg" />
          </li>

        </ul>

        <ul class="f-s-14">

          <li>
            <strong class="f-s-16">Tools</strong> - You have mentioned options in the tools.
          </li>

        </ul>

        <img style="margin-left: 40px;" src="../../../../assets/images/logos/wrappedscrolling.jpg" />

      </div>

      <div id="download-fbi-receipt">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'download-fbi-receipt'">
          Download FBI Receipt
        </h2>

        <p class="f-s-14">
          You can directly download the FBI receipt in PDF format.
        </p>


      </div>

      <div id="view-xml">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'view-xml'">
          View in XML
        </h2>

        <p class="f-s-14">
          You can view the receipt in XML format.
        </p>

      </div>

      <div id="download-xml">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'download-xml'">
          Download in XML
        </h2>

        <p class="f-s-14">
          You can directly download the receipt in XML format.
        </p>


      </div>
    </div>
  </div>

  <div class="col-lg-3">

    <div class="on-page-sidebar">

      <p class="sidebar-title">On this page</p>

      <ul class="scroll-container borderleft submenu-level-2">

        <li [class.active]="selectedSection === 'submissionhistorysdata'"
            (click)="changeSection('submissionhistorysdata')">

          <a>Submission History</a>

        </li>

        <li [class.active]="selectedSection === 'search-submissions'"
            (click)="changeSection('search-submissions')">

          <a>Search Submissions</a>

        </li>

        <li [class.active]="selectedSection === 'filter'"
            (click)="changeSection('filter')">

          <a>Filter</a>

        </li>

        <li [class.active]="selectedSection === 'show-error'"
            (click)="changeSection('show-error')">

          <a>Show Error</a>

        </li>

        <li [class.active]="selectedSection === 'print-fbi-receipt'"
            (click)="changeSection('print-fbi-receipt')">

          <a>Print FBI Receipt</a>

        </li>

        <li [class.active]="selectedSection === 'download-fbi-receipt'"
            (click)="changeSection('download-fbi-receipt')">

          <a>Download FBI Receipt</a>

        </li>

        <li [class.active]="selectedSection === 'view-xml'"
            (click)="changeSection('view-xml')">

          <a>View in XML</a>

        </li>

        <li [class.active]="selectedSection === 'download-xml'"
            (click)="changeSection('download-xml')">

          <a>Download in XML</a>

        </li>

      </ul>

    </div>

  </div>

</div>
